export default __webpack_public_path__ + "static/media/memusic.6dfab8e4.svg";